import { ArgyleIncomeStream } from './models/argyle';

type ArgyleIncomeStreamRaw = ArgyleIncomeStream & Record<string, unknown>;

// Map API stream payload (camelCase or PascalCase) onto the report model.
export function normalizeArgyleIncomeStream(raw: ArgyleIncomeStream): ArgyleIncomeStream {
  const r = raw as ArgyleIncomeStreamRaw;
  const stream = Object.assign(new ArgyleIncomeStream(), raw);

  if (stream.streamType == null && r['StreamType'] != null) {
    stream.streamType = Number(r['StreamType']);
  }
  if (stream.subType == null && r['SubType'] != null) {
    stream.subType = Number(r['SubType']);
  }
  if (!stream.streamIdentifier && r['StreamIdentifier']) {
    stream.streamIdentifier = String(r['StreamIdentifier']);
  }

  return stream;
}
